export enum USER_ROLE {
  SUPERADMIN = 'SUPERADMIN',
  TECH_ADMIN = 'TECH_ADMIN',
  ADMIN = 'ADMIN',
  DISTRIBUTOR = 'DISTRIBUTOR',
  ANALYTICS = 'ANALYTICS',
  USER = 'USER',
  VIEWER = 'VIEWER'
}

export const USER_ROLES_PRIORITIES = {
    [USER_ROLE.SUPERADMIN]: 1,
    [USER_ROLE.TECH_ADMIN]: 2,
    [USER_ROLE.ADMIN]: 3,
    [USER_ROLE.DISTRIBUTOR]: 4,
    [USER_ROLE.ANALYTICS]: 5,
    [USER_ROLE.USER]: 6,
    [USER_ROLE.VIEWER]: 7,
};
